import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { LandingPageRoutingModule } from './landing-page-routing.module';
import { LandingPageComponent } from './landing-page.component';
import { ThemeModule } from 'src/app/theme/theme.module';
import { ObjetivoComponent } from './objetivo/objetivo.component';
import { GestionComponent } from './gestion/gestion.component';
import { HistoriaComponent } from './historia/historia.component';
import { UsuariosComponent } from './usuarios/usuarios.component';
import { TramitesComponent } from './tramites/tramites.component';
import { PlanoComponent } from './plano/plano.component';
import { AppsComponent } from './apps/apps.component';
import { ContactoComponent } from './contacto/contacto.component';
import { PrincipalComponent } from './principal/principal.component';
import { RegistroTotalComponent } from './registro-total/registro-total.component';
import { RegistroUsuarioPublicoComponent } from './registro-total/componentes/registro-documentacion-vehiculo/registro-usuario-publico/registro-usuario-publico.component';
import { RegistroVehiculoComponent } from './registro-total/componentes/registro-documentacion-vehiculo/registro-vehiculo/registro-vehiculo.component';
import { RegistroDocumentacionVehiculoComponent } from './registro-total/componentes/registro-documentacion-vehiculo/registro-documentacion-vehiculo/registro-documentacion-vehiculo.component';
import { CarouselNoticiasComponent } from './carousel-noticias/carousel-noticias.component';
import { NoticiasComponent } from './noticias/noticias.component';
import { MostrarNoticiaComponent } from './noticias/mostrar-noticia/mostrar-noticia.component';
import { RestorePasswordComponent } from './restore-password/restore-password.component';
import { PreguntasFrecuentesComponent } from './preguntas-frecuentes/preguntas-frecuentes.component';
import { AvisoLegalComponent } from './aviso-legal/aviso-legal.component';
import { PoliticaCookiesComponent } from './politica-cookies/politica-cookies.component';
import { PoliticaPrivacidadComponent } from './politica-privacidad/politica-privacidad.component';


@NgModule({
  declarations: [
    LandingPageComponent,
    ObjetivoComponent,
    GestionComponent,
    HistoriaComponent,
    UsuariosComponent,
    TramitesComponent,
    PlanoComponent,
    AppsComponent,
    ContactoComponent,
    PrincipalComponent,
    RegistroUsuarioPublicoComponent,
    RegistroVehiculoComponent,
    RegistroDocumentacionVehiculoComponent,
    RegistroTotalComponent,
    CarouselNoticiasComponent,
    NoticiasComponent,
    MostrarNoticiaComponent,
    RestorePasswordComponent,
    PreguntasFrecuentesComponent,
    AvisoLegalComponent,
    PoliticaCookiesComponent,
    PoliticaPrivacidadComponent,
  ],
  imports: [
    CommonModule,
    LandingPageRoutingModule,
    ThemeModule
  ],
})
export class LandingPageModule { }
